/*
|-------------------------------------------------------------------------------
| 引导页2
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

/**
 * store
 */
const GuideTwoStore = defineStore({
  state: () => ({
    page: '', // 后端返回的页面标识
  }),
  mutations: {
    updatePage(state, data) {
      state.page = data
    },
  },
})

export default GuideTwoStore
export type IGuideTwoStoreState = IStoreState<
  typeof GuideTwoStore.state
>
